var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { useTranslations } from '.';
export var LocaleNumber = function (_a) {
    var number = _a.number, maxDecimals = _a.maxDecimals;
    var _b = __read(useTranslations(), 2), locale = _b[1];
    try {
        var options = typeof maxDecimals === 'number' ? { maximumFractionDigits: maxDecimals } : {};
        return React.createElement(React.Fragment, null, number.toLocaleString(locale, options));
    }
    catch (error) {
        return React.createElement(React.Fragment, null, number);
    }
};
export var LocaleDate = function (_a) {
    var date = _a.date, format = _a.format;
    var _b = __read(useTranslations(), 2), locale = _b[1];
    var dateWrapper = new Date(date);
    if (dateWrapper.getTime && isNaN(dateWrapper.getTime())) {
        console.error('Invalid date');
        return null;
    }
    try {
        return React.createElement(React.Fragment, null, dateWrapper.toLocaleDateString(locale, format));
    }
    catch (err) {
        return React.createElement(React.Fragment, null, dateWrapper.toLocaleDateString('en-US', format));
    }
};
export var LocaleTime = function (_a) {
    var date = _a.date, format = _a.format;
    var _b = __read(useTranslations(), 2), locale = _b[1];
    var dateWrapper = new Date(date);
    if (dateWrapper.getTime && isNaN(dateWrapper.getTime())) {
        console.error('Invalid date');
        return null;
    }
    try {
        return React.createElement(React.Fragment, null, dateWrapper.toLocaleTimeString(locale, format));
    }
    catch (err) {
        return React.createElement(React.Fragment, null, dateWrapper.toLocaleTimeString('en-US', format));
    }
};
//# sourceMappingURL=locale.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/locale.js
// module id = 580
// module chunks = 0